import { render, staticRenderFns } from "./CardStatistics.vue?vue&type=template&id=41f538dc"
import script from "./CardStatistics.vue?vue&type=script&lang=js"
export * from "./CardStatistics.vue?vue&type=script&lang=js"
import style0 from "./CardStatistics.vue?vue&type=style&index=0&id=41f538dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports